import { LineChartGradientsType } from 'types';

// eslint-disable-next-line import/prefer-default-export
export const LineChartGradients: LineChartGradientsType = {
  onlineOfflineComparison: {
    left: 'linear-gradient(360deg, #F5781E 0%, #FFC148 100%)',
    right: 'linear-gradient(180deg, #12BBF0 0%, #5348DA 100%)',
  },
  attendance: {
    left: 'linear-gradient(270deg, #17ECDF 0%, #0B8E86 100%)',
    right: 'linear-gradient(90deg, #E5225C 0%, #FB61A2 100%)',
  },
};
